import { gql } from '@apollo/client';

export const getAORs = gql`
  query getAORs($businessUnits: [String]) {
    getAORs(businessUnits: $businessUnits) {
      enabled
      id
      name
      version
      businessUnitId
      abbreviation
      isPrimary
      gcSupervisor {
        id
        firstName
        lastName
      }
      gcManager {
        id
        firstName
        lastName
      }
      AORSubSystems {
        id
        aorId
        name
        enabled
        deletedAt
      }
    }
  }
`;
